import { Inject, Injectable } from '@angular/core';
import { PlatformResultBaseOfObjectAndErrorDto } from '@data/_generated-api/platform-api/models/platform-result-base-of-object-and-error-dto';
import { PlatformErrorDto } from '@data/_generated-api/platform-api/models/platform-error-dto';
import { environment } from '@/environments/environment';
import { EgiErrorCode } from '@data/_generated-api/error-mappers/egi-error-code';
import { Router } from '@angular/router';
import { Notifier, NOTIFIER } from '@shared/notifier/types';
import { ApiErrorHttpInterceptor } from '@data/_generated-api/http-interceptors/api-error-http.interceptor';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class UpamErrorInterceptor extends ApiErrorHttpInterceptor<
  PlatformResultBaseOfObjectAndErrorDto,
  PlatformErrorDto
> {
  constructor(
    @Inject(NOTIFIER) notifier: Notifier,
    private readonly router: Router,
    logger: NGXLogger
  ) {
    super(
      {
        url: environment.apiPaths.egituraPlatformApi,
        notifyRanges: [
          {
            from: 0,
            to: Infinity
          }
        ],
        message: e => e.message,
        errorCode: e => e.errorCode,
        errors: r => r.errors,
        traceIdentifier: e => e.traceIdentifier,
        // Een bewuste weigering door de platformmodus (503/423) is geen fout: niet naar Sentry
        skipCaptureCodes: [EgiErrorCode.PlatformUnavailable, EgiErrorCode.PlatformReadOnly],
        exclude: [
          // Authentication & user
          EgiErrorCode.PasswordInvalid,
          EgiErrorCode.EmailPasswordCombinationInvalid,
          EgiErrorCode.PasswordNotSet,
          EgiErrorCode.EmailNotFound,
          EgiErrorCode.RefreshTokenNotFound,
          EgiErrorCode.RefreshTokenNotProvided,
          EgiErrorCode.EmailNotFound,
          EgiErrorCode.InvalidRefreshToken,
          EgiErrorCode.BadgeHexNotFound,
          EgiErrorCode.BadgeNotLinkedToUserAccount,
          // Pas na een juist wachtwoord; het loginformulier toont het zelf, vertaald
          EgiErrorCode.UserAccountSoftDeleted,
          // De account-pagina's tonen deze zelf, vertaald en met titel (geen dubbele toast)
          EgiErrorCode.EmailServiceUnavailable,
          // De registratiepagina toont deze zelf, vertaald (de toast gaf de Engelse servertekst erbovenop)
          EgiErrorCode.RegistrationClosed,
          EgiErrorCode.RegistrationKeyInvalid,
          EgiErrorCode.RegistrationNotPossible,
          // Platformmodi: de balk en PlatformModeInterceptor (vertaald) vertellen het al
          EgiErrorCode.PlatformUnavailable,
          EgiErrorCode.PlatformReadOnly,
          // Timesheets
          EgiErrorCode.TimesheetIssue,
          EgiErrorCode.TimesheetEntryOverlaps,
          EgiErrorCode.TimesheetPeriodExceedsThreshold,
          EgiErrorCode.CannotInsertBeforeTimesheetEntry,
          EgiErrorCode.TimesheetsForDayMismatch,
          EgiErrorCode.TimesheetEntriesRequired,
          EgiErrorCode.StartMustPrecedeEndException,
          EgiErrorCode.InsertBeforePeriodNotFound,
          EgiErrorCode.TimesheetEntryNotFound,
          EgiErrorCode.EndCannotExceedNextStart,
          EgiErrorCode.StartCannotPrecedePreviousEnd,
          EgiErrorCode.InsertBeforeEntryNotFound,
          EgiErrorCode.MissingTimeGap
        ]
      },
      notifier,
      logger
    );
  }

  protected notifyServerPossiblyDown() {
    this.notifier.error(
      'Egitura Platform is offline! Contacteer support als dit probleem zich blijft voordoen!'
    );
  }
}
